import React, { useEffect } from 'react';
import './ConfirmModal.css';

// One confirmation dialog for the whole app.
//
// 2026-10-15: there was one, but it was DeleteConfirmationModal — generic in everything except its
// hardcoded "Confirm Deletion" heading and "Delete" button. Logging out needed the same dialog with
// two different words in it, and a second copy of a confirmation dialog is how an app ends up
// asking "are you sure?" in two visual languages.
//
// A dialog, deliberately, where Profile is a panel: panels are places you browse, dialogs are
// decisions with an outcome. Logging out is a decision.
const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'danger',          // 'danger' for destructive, 'brand' for ordinary (styles/buttons.css)
  onConfirm,
  onClose,
}) => {
  // Escape cancels. A confirmation that can only be dismissed by aiming at a small × is a dialog
  // people click through to be rid of, which defeats the point of asking.
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="confirm-overlay" onClick={onClose} role="presentation">
      {/* Clicking the scrim cancels; clicking the dialog must not, hence stopPropagation. */}
      <div
        className="confirm-content"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="confirm-title" id="confirm-title">{title}</h2>
        {message && <p className="confirm-message">{message}</p>}
        <div className="btn-row">
          {/* Cancel first in the DOM so it takes focus, and the safe answer is the one a stray
              Return key gives. */}
          <button type="button" className="btn btn--secondary" onClick={onClose}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`btn btn--${tone === 'brand' ? 'primary' : tone}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
